import { IconName } from '@/components/atoms/Icon';

// DOM CustomEvent used by the admin-app shell (Vue) to open the persistent
// New Content modal that lives inside the content-studio React island.
// The modal listens for this event on `document`; entry points dispatch it.
export const OPEN_NEW_CONTENT_MODAL_EVENT = 'cl:open-new-content-modal';

export enum NewContentModalStep {
  WorkspaceUpload = 1,
  ClipCuration = 2
}

export type AspectRatioValue = '16:9' | '9:16' | '1:1';

export const ASPECT_RATIO_OPTIONS: {
  value: AspectRatioValue;
  ratioLabel: string;
  subLabel: string;
  icon: IconName;
  platformIcons: IconName[];
}[] = [
  {
    value: '16:9',
    ratioLabel: '16:9',
    subLabel: 'Landscape',
    icon: 'IconRectangle',
    platformIcons: ['IconBrandYoutubeFilled', 'IconBrandLinkedinFilled', 'IconWorld']
  },
  {
    value: '9:16',
    ratioLabel: '9:16',
    subLabel: 'Portrait',
    icon: 'IconRectangleVertical',
    platformIcons: ['IconBrandYoutubeFilled', 'IconBrandTiktokFilled', 'IconBrandInstagram']
  },
  {
    value: '1:1',
    ratioLabel: '1:1',
    subLabel: 'Square',
    icon: 'IconSquare',
    platformIcons: ['IconBrandLinkedinFilled', 'IconBrandX', 'IconBrandInstagram']
  }
];
